import React, { useState } from "react";
import { Link } from "react-router-dom";
import { forgotPassword } from "../api/authService";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await forgotPassword(email);
      // Always show generic success, regardless of whether email exists.
      setSubmitted(true);
    } catch (err) {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <div style={{ textAlign: "center", marginBottom: 24 }}>
          <h2 style={{ margin: 0 }}>Forgot Password</h2>
          <p style={{ color: "#6b7280", fontSize: 13, marginTop: 4 }}>
            Enter your email and we'll send you a reset link
          </p>
        </div>

        {submitted ? (
          <div>
            <p style={{ color: "#1a7f37", fontSize: 14, textAlign: "center" }}>
              If that email exists in our system, a password reset link has been sent.
            </p>
            <p style={{ textAlign: "center", fontSize: 13, marginTop: 20 }}>
              <Link to="/login" style={{ color: "#0b2545", fontWeight: 600 }}>
                Back to sign in
              </Link>
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Email address</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@company.com"
                required
              />
            </div>

            {error && <div className="form-error">{error}</div>}

            <button type="submit" className="btn-primary" style={{ width: "100%", marginTop: 8 }} disabled={loading}>
              {loading ? "Sending..." : "Send reset link"}
            </button>

            <p style={{ textAlign: "center", fontSize: 13, marginTop: 20, color: "#6b7280" }}>
              <Link to="/login" style={{ color: "#0b2545", fontWeight: 600 }}>
                Back to sign in
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  );
}
